// extracted by mini-css-extract-plugin
export default {"containerNav":"Nav_containerNav__A6zs6","logo":"Nav_logo__QR8zV","link":"Nav_link__fadND","linkContato":"Nav_linkContato__3VIM6","gradientMove":"Nav_gradientMove__zs2oR"};